import {
  defaultFontTitle,
  blackColor,
  grayColor,
  dangerColor,
  defaultFontButton,
  hexToRgb,
  defaultFont
} from "assets/jss/material-dashboard-react.js";

const cardBodyStyle = {
  cardBody: {
    padding: "0.9375rem 20px",
    flex: "1 1 auto",
    WebkitBoxFlex: "1",
    position: "relative",
  },
  cardBodyPlain: {
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  cardBodyProfile: {
    marginTop: "15px",
  },
  DialogStyle: {
    borderTopLeftRadius: 30,
    borderBottomRightRadius: 60,
  },
  styleDialogContent: {
    background: "rgb(247, 247, 247)",
  },
  containerMap: {
    position: "relative",
    flexWrap: "inherit",
    height: "300px",
    width: "100%",
  },
  titleCardFilter: {
    ...defaultFontTitle,
    fontSize: 22,
    marginBottom: 5,
  },
  titleCard: {
    ...defaultFontTitle,
    fontSize: 18,
    marginBottom: 5,
  },
  buttonSubmit: {
    width: 200,
    padding: "8px 20px",
    fontSize: 14,
    color: "#fff",
    ...defaultFontButton,
    backgroundColor: dangerColor[0],
    borderColor: dangerColor[0],
    borderRadius: 1,
    "&:hover": {
      backgroundColor: blackColor,
    },
    "&:disabled": {
      backgroundColor: grayColor[11],
    },
  },
  iconDefault: {
    fontSize: 22,
    color: "#000",
    verticalAlign: "middle",
    margin: 4,
  },
  lineBottom: {
    marginTop: 5,
    background: dangerColor[0],
    padding: 1,
    borderRadius: 10,
    width: 100,
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.2)",
  },
  containerProfile: {
    background: "#FFF",
    padding: 20,
    border: "1px solid rgb(241, 241, 241)",
    borderRadius: 6,
    width: "98%",
    margin: 5,
  },
  footer2: {
    bottom: 0,
    borderTop: "1px solid rgb(241, 241, 241)",
    padding: "10px 0",
    ...defaultFont,
    width: "100%",
    backgroundColor: "#fff",
    position: "absolute",
  },
  right: {
    marginRight: 50,
    fontSize: "12px",
    float: "right!important",
  },
};

export default cardBodyStyle;
